(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3SurveyModal', {
            templateUrl: 'app/shared/modals/survey-modal.component.html',
            controller: SurveyModalComponent,
            bindings: {
                close: '&',
                dismiss: '&',
                resolve: '<' 
            }
        });

    SurveyModalComponent.$inject = ['Survey'];
    function SurveyModalComponent(Survey) {
        var ctrl = this;
        ctrl.$onInit = init;
        ctrl.data = null;
        ctrl.form = null;
        ctrl.submit = submit;

        //////////////////////////////////////////////

        function init() {
            ctrl.data = ctrl.resolve.data;
        }

        function submit(isCancel) {
            var form = ctrl.form,
                data = ctrl.data,
                close = ctrl.close.bind(ctrl);

            if (isCancel) data.answerId = null;
            if (form.$valid || isCancel) {
                Survey.saveQuestion({}, data).$promise.then(close, close);
            }
        }
    }
})();